"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterItemList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _contants = require("../contants");
var _Button = _interopRequireDefault(require("../../../Button"));
var _FilterItem = require("./FilterItem");
// Components:

// Interfaces:

var FilterItemList = exports.FilterItemList = function FilterItemList(props) {
  var _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    value = props.value,
    options = props.options,
    handleItemClick = props.handleItemClick,
    handleClickDone = props.handleClickDone,
    isHotelOnly = props.isHotelOnly;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledScrollWrapper, {
    showScroll: !isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledFilterItems, null, options.map(function (option) {
    var id = option.id,
      label = option.label,
      filters = option.filters;
    if ((0, _isEmpty2["default"])(filters)) return null;
    var hasLabel = !(0, _isEmpty2["default"])(label);
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: id
    }, hasLabel ? /*#__PURE__*/_react["default"].createElement(StyledLabel, null, label) : null, filters.map(function (filter) {
      return /*#__PURE__*/_react["default"].createElement(_FilterItem.FilterItem, (0, _extends2["default"])({
        key: filter.id,
        value: value,
        handleItemClick: handleItemClick,
        isHotelOnly: isHotelOnly
      }, filter));
    }));
  }))), !isMobile && /*#__PURE__*/_react["default"].createElement(StyledCloseButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
    primary: true,
    onClick: handleClickDone
  }, _contants.CLOSE_BUTTON_TEXT)));
};
var StyledScrollWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemList__StyledScrollWrapper",
  componentId: "sc-fppsr1-0"
})(["min-width:300px;padding:0 8px;", ""], function (_ref) {
  var showScroll = _ref.showScroll;
  return showScroll && "\n      overflow-y: auto;\n      max-height: 380px;\n      padding-bottom: 10px;\n    ";
});
var StyledFilterItems = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemList__StyledFilterItems",
  componentId: "sc-fppsr1-1"
})(["overflow:hidden;display:flex;flex-direction:column;gap:16px;"]);
var StyledLabel = _styledComponents["default"].p.withConfig({
  displayName: "FilterItemList__StyledLabel",
  componentId: "sc-fppsr1-2"
})(["font-size:16px;font-style:normal;font-weight:500;"]);
var StyledCloseButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemList__StyledCloseButtonWrapper",
  componentId: "sc-fppsr1-3"
})(["padding:0 10px 10px;position:relative;::before{position:absolute;content:'';pointer-events:none;height:30px;top:-30px;left:0;right:0;background-image:linear-gradient( to bottom,rgba(255,255,255,0),", " 70% );}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var StyledCloseButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "FilterItemList__StyledCloseButton",
  componentId: "sc-fppsr1-4"
})(["font-size:14px;display:block;width:100%;"]);